import zlgcloudhelper from '../native/zlgcloudhelper.js'

export default {
  async refreshOrderList ({commit}) {
    zlgcloudhelper.queryOrders().then(res => {
      let list = res.data.sort(function (a, b) {
        if (parseInt(a.ID) === parseInt(b.ID)) {
          return parseInt(a.ItemCode.replace(/[^0-9]/ig, '')) - parseInt(b.ItemCode.replace(/[^0-9]/ig, ''))
        } else {
          return parseInt(a.ID) - parseInt(b.ID)
        }
      })
      commit('SET_ORDERLIST', list)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js